export default {
    setInstance(state, instance) {
        state.instance = instance
    },
    setContent(state, content) {
        state.content = content
    }
}